/**
 * Static locale configuration for the admin UI
 * @description Defines all supported locales with only the fields needed by the UI
 */
export interface Locale {
  /** The locale code (ISO 639-1) */
  code: string;
  /** The human-readable language name */
  language: string;
}

/**
 * List of supported locales
 * @description Static list of locales supported by the admin application
 * Must match the API's expected locale codes: en,fr,zh-cn,zh-tw,ja,de,es,nl,it,ru,tr,pt-br
 */
export const SUPPORTED_LOCALES: Locale[] = [
  {
    code: 'en',
    language: 'English',
  },
  {
    code: 'es',
    language: 'Spanish',
  },
  {
    code: 'fr',
    language: 'French',
  },
  {
    code: 'de',
    language: 'German',
  },
  {
    code: 'zh-cn',
    language: 'Chinese (Simplified)',
  },
  {
    code: 'zh-tw',
    language: 'Chinese (Traditional)',
  },
  {
    code: 'ja',
    language: 'Japanese',
  },
  {
    code: 'pt-br',
    language: 'Portuguese (Brazil)',
  },
  {
    code: 'it',
    language: 'Italian',
  },
  {
    code: 'nl',
    language: 'Dutch',
  },
  {
    code: 'ru',
    language: 'Russian',
  },
  {
    code: 'tr',
    language: 'Turkish',
  },
];
